/**
 * Data Axle Service
 * Fetches demographic data from the Data Axle API
 */

import API from '../api.provider';

/**
 * Get aggregated demographics for insights page
 * SECURITY: No longer passes organizationId - backend gets it from authenticated user
 */
export const getAggregatedDemographics = async () => {
  try {
    const response = await API.get('/api/v2/data-axle/demographics');
    return response.data;
  } catch (error) {
    console.error('Error fetching demographics:', error);
    return { success: false, data: null };
  }
};

/**
 * Get enrichment status
 * SECURITY: No longer passes organizationId - backend gets it from authenticated user
 */
export const getEnrichmentStatus = async () => {
  try {
    const response = await API.get('/api/v2/data-axle/status');
    return response.data;
  } catch (error) {
    console.error('Error fetching enrichment status:', error);
    return { success: false };
  }
};

export default {
  getAggregatedDemographics,
  getEnrichmentStatus
};